<template>
  <v-dialog v-model="alert" max-width="500">
    <v-card tile>
      <v-card style="padding: 20px; text-align: center">
        <div class="title" v-if="orderId !== null">
          {{ $t("dialogOrderCreated.orderNumber1") }}

          <router-link
            target="_blank"
            style="text-decoration: none"
            :to="{ name: 'order', params: { order_id: orderId } }"
          >
            {{ orderId }}
          </router-link>

          {{ $t("dialogOrderCreated.orderNumber2") }}
        </div>
        <div
          class="title"
          v-else-if="errorMessage && errorMessage.bill === 'null payment'"
        >
          {{ $t("dialogOrderCreated.unableCreate") }} <br />
          {{ $t("dialogOrderCreated.noPayment") }}
        </div>
        <div
          class="title"
          v-else-if="
            (errorMessage && errorMessage.persons === 'wrong persons number') ||
            (errorMessage &&
              errorMessage.datetime_start ===
                'Free sessions not found for this event on this location at given time')
          "
        >
          {{ $t("dialogOrderCreated.unableCreate") }} <br />
          {{ $t("dialogOrderCreated.timeSlotBusy") }}
        </div>
        <div class="title" v-else-if="errorMessage && errorMessage.phone">
          {{ $t("dialogOrderCreated.unableCreate") }} <br />
          {{ $t("dialogOrderCreated.validationPhone") }}
        </div>
        <div
          class="title"
          v-else-if="errorMessage && errorMessage.seller === 'not found'"
        >
          {{ $t("dialogOrderCreated.unableCreate") }} <br />
          {{ $t("dialogOrderCreated.sellerNotFound") }}
        </div>
        <div
          class="title"
          v-else-if="
            errorMessage &&
            Array.isArray(errorMessage.seller) &&
            errorMessage.seller[0] === 'Must be a valid UUID.'
          "
        >
          {{ $t("dialogOrderCreated.unableCreate") }} <br />
          {{ $t("dialogOrderCreated.sellerNotCorrect") }}
        </div>
        <div
          class="title"
          v-else-if="errorMessage && errorMessage.cancel_delay"
        >
          {{ $t("dialogOrderCreated.unableCreate") }} <br />
          {{ errorMessage.cancel_delay }}
        </div>
        <div class="title" v-else>
          {{ $t("dialogOrderCreated.unableCreate") }} <br />
          {{ $t("dialogOrderCreated.tryLater") }}
        </div>
      </v-card>
      <v-card-actions class="justify-end">
        <v-btn text @click="closeAlert">{{ $t("btnClose") }} </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "OrderInformationModal",
  props: {
    alert: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["orderId", "errorMessage"]),
  },
  methods: {
    closeAlert() {
      this.$emit("close-alert");
    },
  },
};
</script>
